(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amb-home-scroll-fade"]) return;
  try {
    
  (() => {
    const init = () => {
      const hero = document.querySelector('.hero');
      const media = hero?.querySelector('.hero__media-grid');
      if (!hero || !media) return;

      const fade = document.createElement('div');
      fade.className = 'amb-home-scroll-fade__overlay';
      media.appendChild(fade);

      const update = () => {
        const bestSellers = Array.from(document.querySelectorAll('.amb-product-showcase')).find((section) => {
          const heading = section.querySelector('h2');
          return heading && heading.textContent.trim().toUpperCase() === 'BEST SELLERS';
        });

        if (!bestSellers || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          fade.style.opacity = '1';
          return;
        }

        const bestTop = bestSellers.getBoundingClientRect().top;
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const start = viewport * 1.05;
        const end = viewport * 0.45;
        const progress = Math.min(1, Math.max(0, (start - bestTop) / (start - end)));
        fade.style.opacity = String(progress);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          update();
        });
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
